import React, { useRef, useEffect } from 'react';
import ActivityCard from './ActivityCard';
import './ActivitiesCarousel.css';



// Import images directly
import crescendoImage from './Images/LKG.jpg';
import crescendoLogo from './Images/logo.png';
import pinnacleImage from './Images/Game.jpeg';
import pinnacleLogo from './Images/logo.png';
import upskillImage from './Images/ClassRoom.JPG';
import upskillLogo from './Images/logo.png';
import ScienceLab from './Images/Science Lab.jpeg';

const activities = [
    {
        title: 'Modern Class Room',
        description: `"Welcome to our classrooms, vibrant spaces where students are inspired to learn, explore, and grow every day. Here, knowledge meets curiosity."`,
        image: crescendoImage,
        logo: crescendoLogo,
    },
    {
        title: 'Carrom Activity',
        description: `"The activity promotes teamwork, patience, and friendly competition, making it a favorite pastime in schools and recreational spaces."`,
        image: pinnacleImage,
        logo: pinnacleLogo,
    },
    {
        title: 'Science Lab',
        description: `"A school science lab is a dynamic environment where students explore the wonders of science through hands-on experiments and practical learning."`,
        image: ScienceLab,
        logo: upskillLogo,
    },
    {
        title: 'Class Room',
        description: `"A school classroom is a vibrant space where curiosity meets knowledge, filled with eager minds, colorful charts, and the hum of learning."`,
        image: upskillImage,
        logo: upskillLogo,
    },
];

function ActivitiesCarousel() {
    const carouselRef = useRef(null);

    useEffect(() => {
        const scrollInterval = setInterval(() => {
            if (carouselRef.current) {
                const maxScrollLeft = carouselRef.current.scrollWidth - carouselRef.current.clientWidth;

                // If we are at the end, reset to start; else, keep scrolling right
                if (carouselRef.current.scrollLeft >= maxScrollLeft) {
                    carouselRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    carouselRef.current.scrollBy({ left: 300, behavior: 'smooth' });
                }
            }
        }, 3000); // Adjust duration (in ms) between each scroll

        return () => clearInterval(scrollInterval); // Cleanup interval on unmount
    }, []);

    return (
        <div className="carousel-container">
             <h2 style={{
            fontFamily: 'Almendra SC, serif',
            fontSize: '40px',
            fontWeight: 'bold',
            color: '#00008B', // Dark Blue Color
            letterSpacing: '2px',
            textShadow: '2px 2px 4px #aaa',
            padding: '10px',
            borderRadius: '8px',
        }}>
            SCHOOL ACTIVITIES
        </h2>
            <div className="carousel" ref={carouselRef}>
                {activities.map((activity, index) => (
                    <ActivityCard key={index} {...activity} />
                ))}
            </div>
        </div>
    );
}

export default ActivitiesCarousel;
